export var apiPath='/v1/users';var actionType='USER_ASSETS';export default actionType;